import PropTypes from 'prop-types';
import './card-ribbon.css';

/**
 * Диагональная лента-оверлей на углу карточки («HOT», «RESERVED»).
 *
 * Вынесена из атома `Badge` (#1323, пункт 21): лента 128×128 с
 * `position: absolute` и двумя псевдоэлементами — это декоративный оверлей
 * карточки, а не бейдж. Держать два несвязанных режима отображения в одном
 * атоме мешало и паритету между фронтами (`component-parity.md` §4), и
 * пониманию, что вообще делает `Badge`.
 *
 * Требует позиционированного предка — на карточке это `.car-card__media`.
 */
export const CardRibbon = ({ children, variant, className = '' }) => (
  <div className={`card-ribbon card-ribbon--${variant} ${className}`.trim()}>
    <span>{children}</span>
  </div>
);

CardRibbon.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['hot', 'sold']).isRequired,
  className: PropTypes.string,
};

export default CardRibbon;
